angular.module('rjmNg.directives').directive "structureSync", [
  () ->
    restrict: "E"
    templateUrl: "directive.structureSync.html"
    replace: true
    controller: [
      "$routeParams"
      "$scope"
      "InputConnections"
      "jobService"
      "notification"
      "emailNotificationService"
      "email"
      "jobTypes"
      "logger"
      "connectionUtils"
      "CONNECTIONS"
      (
        $routeParams
        $scope
        InputConnections
        jobService
        notification
        emailNotificationService
        email
        jobTypes
        logger
        connectionUtils
        CONNECTIONS
      ) ->

        InputConnectionsInstance = InputConnections($routeParams.clientId)

        $scope.forceStructSync = () ->

          if confirm "This will run a structure sync. Are you sure you want to do this?"
            InputConnectionsInstance.get().then (connections) ->

              _emailMeAtStart()
              _emailMeWhenComplete()

              connections = connections.filter (connection) ->
                connectionUtils.connectionIsDatabase(connection) or
                  connection.type is CONNECTIONS.TYPES.PUSH_API

              connections = connectionIds: _.pluck(connections, 'meta_id')

              # Request structure sync
              jobService(jobTypes.STRUCT_SYNC)
                .queue(connections, _handleSuccess, _handleError)

              logger.log('Structure Sync Queued', 'Open', 1, 'create')
              $scope.alertMessage = ''
            , (error) ->
              _handleError()

          # This will email the user when the structure sync completes
          # If a support user clicks it, they will get the email and not the regular user
          _emailMeWhenComplete = () ->
            emailNotificationService.post(email.TYPE.STRUCTURE_SYNC_COMPLETION)

          # This will email the user when the structure sync starts
          _emailMeAtStart = () ->
            emailNotificationService.post(email.TYPE.STRUCTURE_SYNC_START)

          _handleSuccess = () ->
            notification.success(
              "Queuing structure sync.",
              "Queuing structure sync.
                We'll send you an email when it completes.",
              "global"
            )

          _handleError = () ->
            notification.error(
              "Unable to queue structure sync",
              "Unable to queue structure sync at this time, please try again later.",
              "global"
            )

    ]
    link: (scope, element, attrs) ->
      # Allows you to set custom text for the button
      if attrs.buttonText?
        scope.title = attrs.buttonText
      else
        scope.title = 'Sync Structure'
]
